import React, { useEffect, useState } from 'react';
import { Input, Label } from '../../css/Shared';
import { useAppContext } from '../../context/AppContext';
import axios from 'axios';
import States from '../../components/States';
import api from '../../components/Api';
import { toast } from 'react-toastify';
import FacilitySearchSelect from '../../components/SearchableSelect';


const MailProvider = ({
  onClose,
  provider,
  reset,
  setReset,
  editProviderItemId,
 onCreated,
 normalizedFacilities
}) => {

  const { authState, axiUrl } = useAppContext();

  const [formData, setFormData] = useState({
    providerName: '',
    name: '',
    address: '',
    address2: '',
    city: '',
    state: 'FL',
    zip: '',
    crid: '',
    mid: '',
    repname: '',
    repphone: '',
    repemail: '',
    einduction: false,
    seamless: false,
     bmeuFacility: null,  
    company: authState?.user.company,
  });

useEffect(() => {
  if (!provider || !normalizedFacilities?.length) return;

  const facilityId =
    provider?.bmeuFacility?.dropkey || null;

  const selectedFacility = normalizedFacilities.find(
    f => String(f.dropkey) === String(facilityId)
  ) || null;

  setFormData(prev => ({
    ...prev,
    ...provider,
    bmeuFacility: selectedFacility,
    company: authState?.user.company
  }));
}, [provider, normalizedFacilities]);




  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async e => {
  e.preventDefault();

  const isUpdate = Boolean(provider);

  try {
    const endpoint = provider
      ? '/permits/updateproviderr'
      : '/permits/addmailprovider';

    const payload = provider
      ? { ...formData, id: provider._id }
      : formData;

    console.log('SENDING PROVIDER:', payload);

    const res = await api.post(endpoint, payload);

    toast.success(isUpdate ? 'Provider updated' : 'Provider saved');

    if (onCreated) {
      onCreated(res.data);
    }

    if (!onCreated && typeof setReset === 'function') {
      setReset(!reset);
    }

    onClose();
  } catch (err) {
    console.error(
      'PROVIDER SAVE FAILED:',
      err.response?.data || err.message
    );
  }
};


console.log(normalizedFacilities)
console.log(formData)
  return (
    <div
      className="
        max-h-[80vh]
        overflow-y-auto
        max-w-6xl
        mx-auto
        px-6
        py-4
        text-sm
        [&_input]:h-9
        [&_input]:text-sm
        [&_input]:px-3
        [&_label]:text-xs
      "
    >
      <form onSubmit={handleSubmit} className="space-y-6">

        <h2 className="text-base font-semibold text-gray-800">
          {provider  ? 'Edit Mail Provider' : 'New Mail Provider'}
        </h2>

        <InputGroup
          label="Mail agent / service provider"
          name="providerName"
          value={formData.providerName}
          onChange={handleChange}
        />

        {/* MAIL AGENT */}
        <Section title="Mail Agent">
          <div className="grid grid-cols-1 md:grid-cols-6 gap-4">

            <div className="md:col-span-6">
              <InputGroup label="Company" name="name" value={formData.name} onChange={handleChange} />
            </div>

            <div className="md:col-span-3">
              <InputGroup label="Address 1" name="address" value={formData.address} onChange={handleChange} />
            </div>

            <div className="md:col-span-3">
              <InputGroup label="Address 2" name="address2" value={formData.address2} onChange={handleChange} />
            </div>

            <div className="md:col-span-3">
              <InputGroup label="City" name="city" value={formData.city} onChange={handleChange} />
            </div>

            <div className="md:col-span-1">
              <Label muted>State</Label>
              <States setFormData={setFormData} formData={formData} />
            </div>

            <div className="md:col-span-2">
              <InputGroup label="Zip" name="zip" value={formData.zip} onChange={handleChange} />
            </div>

            <div className="md:col-span-3">
              <InputGroup label="CRID" name="crid" value={formData.crid} onChange={handleChange} />
            </div>

            <div className="md:col-span-3">
              <InputGroup label="MID" name="mid" value={formData.mid} onChange={handleChange} />
            </div>

          </div>
        </Section>

        {/* REPRESENTATIVE */}
        <Section title="Representative">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <InputGroup label="Name" name="repname" value={formData.repname} onChange={handleChange} required/>
            <InputGroup label="Phone" name="repphone" value={formData.repphone} onChange={handleChange} required/>
            <InputGroup label="Email" name="repemail" value={formData.repemail} onChange={handleChange} required/>
          </div>
        </Section>

        {/* SERVICE OPTIONS */}
        <Section title="Service Options">
          <div className="flex flex-wrap gap-6">
            <label className="flex items-center gap-2 text-xs">
              <input
                type="checkbox"
                name="einduction"
                checked={formData.einduction}
                onChange={handleChange}
                className="scale-90"
              />
              eInduction
            </label>

            <label className="flex items-center gap-2 text-xs">
              <input
                type="checkbox"
                name="seamless"
                checked={formData.seamless}
                onChange={handleChange}
                className="scale-90"
              />
              Seamless Acceptance
            </label>
          </div>
        </Section>
<Section title="Post Office Entry">
  <div style={{ padding: '10px 0px' }}>
    <Label muted>Post Office of Entry Location</Label>

    <FacilitySearchSelect
      facilities={normalizedFacilities}
      value={formData.bmeuFacility}
      onChange={(facility) =>
        setFormData(prev => ({
          ...prev,
          bmeuFacility: facility
        }))
      }
    />
  </div>
</Section>

        <div className="flex justify-end gap-3 pt-2">
          <button type="button" onClick={onClose} className="btn-secondary">
            Cancel
          </button>
          <button type="submit" className="btn-primary">
            Save
          </button>
        </div>

      </form>
    </div>
  );
};

/* helpers */

const Section = ({ title, children }) => (
  <section className="border rounded-lg p-4">
    <h3 className="text-xs font-medium text-gray-500 mb-3 uppercase tracking-wide">
      {title}
    </h3>
    {children}
  </section>
);

const InputGroup = ({ label, name, value, onChange,required }) => (
  <div>
    <Label muted>{label}</Label>
    <Input name={name} value={value} onChange={onChange} required={required} />
  </div>
);

export default MailProvider;
